import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { get, over } from '@totalsoft/react-state-lens';
import { Autocomplete, Card, IconButton } from '@totalsoft/rocket-ui';
import { Box, Grid } from '@mui/material';
import FlexBox from 'components/common/FlexBox';
import { useTranslation } from 'react-i18next';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { ThemedWrapper } from 'components/common/SurfaceStyles';

const LinkingComponent = ({ lens, typesSummary, linkingTypes, onDelete, validation, disabled }) => {
  const { t } = useTranslation();

  const linkingErrors = useMemo(() => getErrors(validation), [validation]);

  const type = { id: lens.typeId |> get, name: lens.typeName |> get };
  const source = { id: lens.sourceId |> get, name: lens.sourceName |> get };
  const destination = { id: lens.destinationId |> get, name: lens.destinationName |> get };

  const handleChange = prefix => value => {
    over(lens, prev => ({ ...prev, [`${prefix}Id`]: value.id, [`${prefix}Name`]: value.name }));
  };

  return (
    <Card disablePadding>
      <FlexBox gap={2} alignItems='center' p={2.5}>
        <Grid container spacing={2} flexGrow={1}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              required
              label={t('LeasingServiceType.LinkingSource')}
              value={source}
              onChange={handleChange('source')}
              options={typesSummary}
              error={!isValid(validation.sourceId)}
              helperText={getErrors(validation.sourceId)}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              required
              label={t('LeasingServiceType.LinkingType')}
              value={type}
              onChange={handleChange('type')}
              options={linkingTypes}
              error={!isValid(validation.typeId)}
              helperText={getErrors(validation.typeId)}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              required
              label={t('LeasingServiceType.LinkingDestination')}
              value={destination}
              onChange={handleChange('destination')}
              options={typesSummary}
              error={!isValid(validation.destinationId)}
              helperText={getErrors(validation.destinationId)}
              disabled={disabled}
            />
          </Grid>
          {linkingErrors && (
            <Grid item xs={12}>
              <ThemedWrapper color='error'>{linkingErrors}</ThemedWrapper>
            </Grid>
          )}
        </Grid>
        <Box>
          <IconButton
            type='delete'
            color='error'
            size='small'
            variant='text'
            tooltip={t('Delete')}
            onClick={() => onDelete(lens.id |> get)}
            disabled={disabled}
          />
        </Box>
      </FlexBox>
    </Card>
  );
};

LinkingComponent.propTypes = {
  lens: PropTypes.object,
  typesSummary: PropTypes.array,
  linkingTypes: PropTypes.array,
  onDelete: PropTypes.func,
  validation: PropTypes.object,
  disabled: PropTypes.bool
};

export default LinkingComponent;
